import React, { useState } from 'react';
import { setUsernameCallable } from '../firebase/config';

const SetUsernameScreen = ({ user }) => {
  const [usernameInput, setUsernameInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleUsernameChange = (e) => {
    const value = e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '');
    setUsernameInput(value);
    setMessage('');
  };

  const handleSaveUsername = async () => {
    setIsLoading(true);
    setMessage('');
    setIsError(false);

    try {
      const result = await setUsernameCallable({ username: usernameInput });
      setMessage(result.data.message);
      setIsError(false);
      // On success, the main App component will automatically navigate to the dashboard
      // because the userProfile will update and no longer be missing a username.
    } catch (error) {
      console.error("Error setting username:", error);
      setMessage(error.message);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-[#1E1E1E]/50 p-8 rounded-lg border border-gray-800 shadow-2xl max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-[#D4AF37] font-serif mb-2">Welcome to Kivlope!</h1>
        <p className="text-gray-400 mb-6">Choose a unique username to get started.</p>

        <div className="mb-4 text-left">
          <label htmlFor="username" className="block text-sm font-bold mb-2 text-gray-400">Username</label>
          <div className="flex items-center">
            <span className="text-gray-500 mr-1 text-lg p-2 bg-gray-800 border border-r-0 border-gray-700 rounded-l-lg">@</span>
            <input
              id="username"
              type="text"
              value={usernameInput}
              onChange={handleUsernameChange}
              className="bg-gray-800 border border-gray-700 rounded-r-lg w-full py-2 px-3 leading-tight focus:outline-none focus:border-[#D4AF37]"
              placeholder="your_username"
              maxLength="20"
            />
          </div>
        </div>

        <button onClick={handleSaveUsername} disabled={isLoading || usernameInput.length < 3} className="w-full bg-[#D4AF37] text-gray-900 font-bold py-2 px-4 rounded-lg hover:bg-yellow-600 disabled:bg-gray-600 disabled:cursor-not-allowed transition-colors duration-300">
          {isLoading ? 'Saving...' : 'Save and Continue'}
        </button>

        {message && <p className={`mt-4 text-sm ${isError ? 'text-red-400' : 'text-green-400'}`}>{message}</p>}
      </div>
    </div>
  );
};

export default SetUsernameScreen;
